import React, { useState, useEffect } from "react";
import {
  clearInterval,
  clearTimeout,
  setInterval,
  setTimeout,
} from "worker-timers";
import APIRequest from "../../../Services/commonAPIConsumer";
import { useIdleTimer, workerTimers } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import Alert from "../../Controls/Alerts/Alerts";
import { useSelector, useDispatch } from "react-redux";
import {
  languageChange,
  currentSelectedLanguage,
} from "../../../StateManagement/actions";


function RefreshToken() {
  var max_refreshtimeout_count = 1500000;
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const history = useNavigate();
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [alertClass, setAlertClass] = useState("alertindex");
  const onIdle = () => {
    refreshToken();
    reset();
  };

  const { reset, isIdle, getRemainingTime } = useIdleTimer({
    onIdle,
    timeout: max_refreshtimeout_count,
    events: [
      //'mousemove',
      //"keydown",
      //'wheel',
      //'DOMMouseScroll',
      //'mousewheel',
      //"mousedown",
      //'touchstart',
      //'touchmove',
      //'MSPointerDown',
      //'MSPointerMove',
      //'visibilitychange'
    ],
    crossTab: true,
    timers: workerTimers,
    debounce: 0,
    throttle: 1,
    startManually: false,
    name: "refresh-timer",
    syncTimers: 1,
  });

  async function refreshToken() {
    var response = await APIRequest.POSTREFRESH(
      `${process.env.REACT_APP_API + process.env.REACT_APP_API_RefreshToken}`
    );
    if (response && response === "Server maintenance") {
      history("/maintenance");
      return;
    }
    if (response && response !== "Failed to fetch") {
      if (response.errorMessage == undefined || response.errorMessage == "") {
      } else {
        setAlertMsg(response.errorMessage);
        setAlertType("warning");
        return;
      }
    } else {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_SessionisExpiredPlease);
      setAlertType("warning");
      return;
    }
  }
  return (
    <>
      <Alert
        alertType={alertType}
        alertMsg={alertMsg}
        setAlertMsg={setAlertMsg}
        setAlertType={setAlertType}
        className={alertClass}
      ></Alert>
    </>
  );
}

export default RefreshToken;
